/**
 * 过渡页
 */
import * as React from 'react'
import classNames from 'classnames'
import { useTranslation } from '@/libs/next-lang'
import styles from './index.module.less'

export default function Loading({ theme = 'dark', text }: any) {
  const isDark: boolean = theme === 'dark'
  const { t } = useTranslation(['components'])

  return (
    <div
      className={styles['loading-page']}
      style={{ backgroundColor: isDark ? '#161819' : '#FFF' }}
    >
      <div
        className={classNames(styles['cube-wrapper'], {
          [styles.dark]: isDark,
          [styles.light]: !isDark,
        })}
      >
        <div className={styles['cube-folding']}>
          <img
            src={
              isDark
                ? 'https://static.creativebooster.com/common/logo-w.png'
                : 'https://static.creativebooster.com/common/logo-d.png'
            }
            alt="logo"
            style={{ height: 62 }}
          />
        </div>
        <span className={styles.loading} data-name="Loading">
          {text || `${t('components:t43')}...`}
        </span>
      </div>
    </div>
  )
}
